(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~menu~select~table~treeSelect"],{

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = ({
  prefixCls: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string.def('rc-menu'),
  focusable: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool.def(true),
  multiple: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  defaultActiveFirst: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  visible: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool.def(true),
  activeKey: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number]),
  selectedKeys: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number])),
  defaultSelectedKeys: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number])).def([]),
  defaultOpenKeys: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number])).def([]),
  openKeys: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number])),
  openAnimation: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object]),
  mode: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']).def('vertical'),
  triggerSubMenuAction: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string.def('hover'),
  subMenuOpenDelay: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number.def(0.1),
  subMenuCloseDelay: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number.def(0.1),
  level: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number.def(1),
  inlineIndent: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number.def(24),
  theme: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['light', 'dark']).def('light'),
  getPopupContainer: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func,
  openTransitionName: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  forceSubMenuRender: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  selectable: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  isRootMenu: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool.def(true),
  builtinPlacements: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object.def(function () {
    return {};
  }),
  itemIcon: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].any,
  expandIcon: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].any,
  overflowedIndicator: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].any
});

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ vc_menu_SubMenu; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ vc_menu_MenuItem; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ MenuItem_props; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ vc_menu_MenuItemGroup; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Divider; });

// UNUSED EXPORTS: MenuItem, MenuItemGroup

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/store/index.js + 3 modules
var utils_store = __webpack_require__(20);

// EXTERNAL MODULE: ./node_modules/omit.js/es/index.js
var es = __webpack_require__(13);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/key_code.js
var key_code = __webpack_require__(9);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/base/vc-menu/utils/isMobile.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// MIT License from https://github.com/kaimallea/isMobile
var applePhone = /iPhone/i;
var appleIpod = /iPod/i;
var appleTablet = /iPad/i;
var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'

var androidTablet = /Android/i;
var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
var windowsPhone = /Windows Phone/i;
var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'

var otherBlackberry = /BlackBerry/i;
var otherBlackberry10 = /BB10/i;
var otherOpera = /Opera Mini/i;
var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'

function match(regex, userAgent) {
  return regex.test(userAgent);
}

function isMobile(userAgent) {
  var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''); // Facebook mobile app's integrated browser adds a bunch of strings that
  // match everything. Strip it out if it exists.

  var tmp = ua.split('[FBAN');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp = tmp;

    var _tmp2 = _slicedToArray(_tmp, 1);

    ua = _tmp2[0];
  } // Twitter mobile app's integrated browser on iPad adds a "Twitter for
  // iPhone" string. Same probably happens on other tablet platforms.
  // This will confuse detection so strip it out if it exists.


  tmp = ua.split('Twitter');

  if (typeof tmp[1] !== 'undefined') {
    var _tmp3 = tmp;

    var _tmp4 = _slicedToArray(_tmp3, 1);

    ua = _tmp4[0];
  }

  var result = {
    apple: {
      phone: match(applePhone, ua) && !match(windowsPhone, ua),
      ipod: match(appleIpod, ua),
      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
    },
    amazon: {
      phone: match(amazonPhone, ua),
      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
      device: match(amazonPhone, ua) || match(amazonTablet, ua)
    },
    android: {
      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
    },
    windows: {
      phone: match(windowsPhone, ua),
      tablet: match(windowsTablet, ua),
      device: match(windowsPhone, ua) || match(windowsTablet, ua)
    },
    other: {
      blackberry: match(otherBlackberry, ua),
      blackberry10: match(otherBlackberry10, ua),
      opera: match(otherOpera, ua),
      firefox: match(otherFirefox, ua),
      chrome: match(otherChrome, ua),
      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
    },
    // Additional
    any: null,
    phone: null,
    tablet: null
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device; // excludes 'other' devices and ipods, targeting touchscreen phones

  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}

var defaultResult = _objectSpread(_objectSpread({}, isMobile()), {}, {
  isMobile: isMobile
});

/* harmony default export */ var utils_isMobile = (defaultResult);
// CONCATENATED MODULE: ./src/base/vc-menu/util.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


function noop() {}
function getKeyFromChildrenIndex(child, menuEventKey, index) {
  var prefix = menuEventKey || '';
  return child.key === undefined ? "".concat(prefix, "item_").concat(index) : child.key;
}
function getMenuIdFromSubMenuEventKey(eventKey) {
  return "".concat(eventKey, "-menu-");
}
function loopMenuItem(children, cb) {
  var index = -1;
  children.forEach(function (c) {
    index++;

    if (c && c.type && c.type.isMenuItemGroup) {
      c.$slots.default.forEach(function (c2) {
        index++;
        c.componentOptions && cb(c2, index);
      });
    } else {
      c.componentOptions && cb(c, index);
    }
  });
}
function loopMenuItemRecursively(children, keys, ret) {
  if (!children || ret.find) {
    return;
  }

  children.forEach(function (c) {
    if (ret.find) {
      return;
    }

    if (c.data && c.data.slot && c.data.slot !== 'default') {
      return;
    }

    if (c && c.componentOptions) {
      var options = c.componentOptions.Ctor.options;

      if (!options || !(options.isSubMenu || options.isMenuItem || options.isMenuItemGroup)) {
        return;
      }

      if (keys.indexOf(c.key) !== -1) {
        ret.find = true;
      } else if (c.componentOptions.children) {
        loopMenuItemRecursively(c.componentOptions.children, keys, ret);
      }
    }
  });
}
var menuAllProps = {
  props: ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator', // the following keys found need to be removed from test regression
  'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon'],
  on: ['select', 'deselect', 'destroy', 'openChange', 'itemHover', 'titleMouseenter', 'titleMouseleave', 'titleClick', 'updateSelectedKeys']
}; // ref: https://github.com/ant-design/ant-design/issues/14007
// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
// getBoundingClientRect return the full precision value, which is
// not the same behavior as on chrome. Set the precision to 6 to
// unify their behavior

var getWidth = function getWidth(elem) {
  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;

  if (width) {
    width = +width.toFixed(6);
  }

  return width || 0;
};
var setStyle = function setStyle(elem, styleProperty, value) {
  if (elem && _typeof(elem.style) === 'object') {
    elem.style[styleProperty] = value;
  }
};
var util_isMobileDevice = function isMobileDevice() {
  return utils_isMobile.any;
};
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(66);

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./src/base/vc-trigger/index.js + 9 modules
var vc_trigger = __webpack_require__(25);

// CONCATENATED MODULE: ./src/base/vc-menu/placements.js
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
/* harmony default export */ var vc_menu_placements = (placements);
// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/requestAnimationTimeout.js + 1 modules
var requestAnimationTimeout = __webpack_require__(27);

// EXTERNAL MODULE: ./src/utils/getTransitionProps.js
var getTransitionProps = __webpack_require__(22);

// CONCATENATED MODULE: ./src/base/vc-menu/SubMenu.jsx



function SubMenu_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { SubMenu_typeof = function _typeof(obj) { return typeof obj; }; } else { SubMenu_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return SubMenu_typeof(obj); }

function SubMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SubMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SubMenu_ownKeys(Object(source), true).forEach(function (key) { SubMenu_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SubMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SubMenu_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var guid = 0;
var popupPlacementMap = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop",
  "inline": "rightTop"
};

var SubMenu_updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
  var menuId = getMenuIdFromSubMenuEventKey(eventKey);
  var state = store.getState();
  store.setState({
    defaultActiveFirst: SubMenu_objectSpread(SubMenu_objectSpread({}, state.defaultActiveFirst), {}, SubMenu_defineProperty({}, menuId, defaultActiveFirst))
  });
};

var SubMenu = {
  name: "SubMenu",
  props: {
    parentMenu: vue_types["a" /* default */].object,
    title: vue_types["a" /* default */].any,
    selectedKeys: vue_types["a" /* default */].array.def([]),
    openKeys: vue_types["a" /* default */].array.def([]),
    openChange: vue_types["a" /* default */].func.def(noop),
    rootPrefixCls: vue_types["a" /* default */].string,
    eventKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    multiple: vue_types["a" /* default */].bool,
    active: vue_types["a" /* default */].bool,
    // TODO: remove
    isRootMenu: vue_types["a" /* default */].bool.def(false),
    index: vue_types["a" /* default */].number,
    triggerSubMenuAction: vue_types["a" /* default */].string,
    popupClassName: vue_types["a" /* default */].string,
    getPopupContainer: vue_types["a" /* default */].func,
    forceSubMenuRender: vue_types["a" /* default */].bool,
    openAnimation: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].object]),
    showCollapseIcon: vue_types["a" /* default */].bool.def(true),
    //是否显示右侧折叠icon
    disabled: vue_types["a" /* default */].bool,
    subMenuOpenDelay: vue_types["a" /* default */].number.def(0.1),
    subMenuCloseDelay: vue_types["a" /* default */].number.def(0.1),
    level: vue_types["a" /* default */].number.def(1),
    inlineIndent: vue_types["a" /* default */].number.def(24),
    openTransitionName: vue_types["a" /* default */].string,
    popupOffset: vue_types["a" /* default */].array,
    isOpen: vue_types["a" /* default */].bool,
    store: vue_types["a" /* default */].object,
    mode: vue_types["a" /* default */].oneOf(["horizontal", "vertical", "vertical-left", "vertical-right", "inline"]).def("vertical"),
    manualRef: vue_types["a" /* default */].func.def(noop),
    builtinPlacements: vue_types["a" /* default */].object.def(function () {
      return {};
    }),
    itemIcon: vue_types["a" /* default */].any,
    expandIcon: vue_types["a" /* default */].any,
    subMenuKey: vue_types["a" /* default */].string
  },
  mixins: [BaseMixin["a" /* default */]],
  isSubMenu: true,
  data: function data() {
    var props = this.$props;
    var store = props.store;
    var eventKey = props.eventKey;
    var defaultActiveFirst = store.getState().defaultActiveFirst;
    var value = false;

    if (defaultActiveFirst) {
      value = defaultActiveFirst[eventKey];
    }

    SubMenu_updateDefaultActiveFirst(store, eventKey, value);
    return {// defaultActiveFirst: false,
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.handleUpdated();
    });
  },
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.handleUpdated();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var eventKey = this.eventKey;

    this.__emit("destroy", eventKey);
    /* istanbul ignore if */


    if (this.minWidthTimeout) {
      Object(requestAnimationTimeout["a" /* cancelAnimationTimeout */])(this.minWidthTimeout);
      this.minWidthTimeout = null;
    }
    /* istanbul ignore if */


    if (this.mouseenterTimeout) {
      Object(requestAnimationTimeout["a" /* cancelAnimationTimeout */])(this.mouseenterTimeout);
      this.mouseenterTimeout = null;
    }
  },
  methods: {
    handleUpdated: function handleUpdated() {
      var _this3 = this;

      var _this$$props = this.$props,
          mode = _this$$props.mode,
          parentMenu = _this$$props.parentMenu,
          manualRef = _this$$props.manualRef; // invoke customized ref to expose component to mixin

      if (manualRef) {
        manualRef(this);
      }

      if (mode !== "horizontal" || !parentMenu.isRootMenu || !this.isOpen) {
        return;
      }

      this.minWidthTimeout = Object(requestAnimationTimeout["b" /* requestAnimationTimeout */])(function () {
        return _this3.adjustWidth();
      }, 0);
    },
    onKeyDown: function onKeyDown(e) {
      var keyCode = e.keyCode;
      var menu = this.menuInstance;
      var _this$$props2 = this.$props,
          store = _this$$props2.store,
          isOpen = _this$$props2.isOpen;

      if (keyCode === key_code["a" /* default */].ENTER) {
        this.onTitleClick(e);
        SubMenu_updateDefaultActiveFirst(store, this.eventKey, true);
        return true;
      }

      if (keyCode === key_code["a" /* default */].RIGHT) {
        if (isOpen) {
          menu.onKeyDown(e);
        } else {
          this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value

          SubMenu_updateDefaultActiveFirst(store, this.eventKey, true);
        }

        return true;
      }

      if (keyCode === key_code["a" /* default */].LEFT) {
        var handled;

        if (isOpen) {
          handled = menu.onKeyDown(e);
        } else {
          return undefined;
        }

        if (!handled) {
          this.triggerOpenChange(false);
          handled = true;
        }

        return handled;
      }

      if (isOpen && (keyCode === key_code["a" /* default */].UP || keyCode === key_code["a" /* default */].DOWN)) {
        return menu.onKeyDown(e);
      }

      return undefined;
    },
    onPopupVisibleChange: function onPopupVisibleChange(visible) {
      this.triggerOpenChange(visible, visible ? "mouseenter" : "mouseleave");
    },
    onMouseEnter: function onMouseEnter(e) {
      var _this$$props3 = this.$props,
          key = _this$$props3.eventKey,
          store = _this$$props3.store;
      SubMenu_updateDefaultActiveFirst(store, key, false);

      this.__emit("mouseenter", {
        key: key,
        domEvent: e
      });
    },
    onMouseLeave: function onMouseLeave(e) {
      var eventKey = this.eventKey,
          parentMenu = this.parentMenu;
      parentMenu.subMenuInstance = this; // parentMenu.subMenuLeaveFn = () => {
      // // trigger mouseleave
      //   this.__emit('mouseleave', {
      //     key: eventKey,
      //     domEvent: e,
      //   })
      // }

      this.__emit("mouseleave", {
        key: eventKey,
        domEvent: e
      }); // prevent popup menu and submenu gap
      // parentMenu.subMenuLeaveTimer = setTimeout(parentMenu.subMenuLeaveFn, 100)

    },
    onTitleMouseEnter: function onTitleMouseEnter(domEvent) {
      var key = this.$props.eventKey; // this.clearSubMenuTitleLeaveTimer()

      this.__emit("itemHover", {
        key: key,
        hover: true
      });

      this.__emit("titleMouseenter", {
        key: key,
        domEvent: domEvent
      });
    },
    onTitleMouseLeave: function onTitleMouseLeave(e) {
      var eventKey = this.eventKey,
          parentMenu = this.parentMenu;
      parentMenu.subMenuInstance = this;

      this.__emit("itemHover", {
        key: eventKey,
        hover: false
      });

      this.__emit("titleMouseleave", {
        key: eventKey,
        domEvent: e
      });
    },
    onTitleClick: function onTitleClick(e) {
      var _this$$props4 = this.$props,
          triggerSubMenuAction = _this$$props4.triggerSubMenuAction,
          eventKey = _this$$props4.eventKey,
          isOpen = _this$$props4.isOpen,
          store = _this$$props4.store;

      this.__emit("titleClick", {
        key: eventKey,
        domEvent: e
      });

      if (triggerSubMenuAction === "hover") {
        return;
      }

      this.triggerOpenChange(!isOpen, "click");
      SubMenu_updateDefaultActiveFirst(store, eventKey, false);
    },
    onUpdateSelectedKeys: function onUpdateSelectedKeys(e) {
      this.__emit('updateSelectedKeys', e);
    },
    onSubMenuClick: function onSubMenuClick(info) {
      this.__emit("click", this.addKeyPath(info));
    },
    getPrefixCls: function getPrefixCls() {
      return "".concat(this.$props.rootPrefixCls, "-submenu");
    },
    getActiveClassName: function getActiveClassName() {
      return "".concat(this.getPrefixCls(), "-active");
    },
    getDisabledClassName: function getDisabledClassName() {
      return "".concat(this.getPrefixCls(), "-disabled");
    },
    getSelectedClassName: function getSelectedClassName() {
      return "".concat(this.getPrefixCls(), "-selected");
    },
    getOpenClassName: function getOpenClassName() {
      return "".concat(this.$props.rootPrefixCls, "-submenu-open");
    },
    saveMenuInstance: function saveMenuInstance(c) {
      // children menu instance
      this.menuInstance = c;
    },
    addKeyPath: function addKeyPath(info) {
      return SubMenu_objectSpread(SubMenu_objectSpread({}, info), {}, {
        keyPath: (info.keyPath || []).concat(this.$props.eventKey)
      });
    },
    // triggerOpenChange (open, type) {
    //   const key = this.$props.eventKey
    //   this.__emit('openChange', {
    //     key,
    //     item: this,
    //     trigger: type,
    //     open,
    //   })
    // },
    triggerOpenChange: function triggerOpenChange(open, type) {
      var _this4 = this;

      var key = this.$props.eventKey;

      var openChange = function openChange() {
        _this4.__emit("openChange", {
          key: key,
          item: _this4,
          trigger: type,
          open: open
        });
      };

      if (type === "mouseenter") {
        // make sure mouseenter happen after other menu item's mouseleave
        this.mouseenterTimeout = Object(requestAnimationTimeout["b" /* requestAnimationTimeout */])(function () {
          openChange();
        }, 0);
      } else {
        openChange();
      }
    },
    isChildrenSelected: function isChildrenSelected() {
      var ret = {
        find: false
      };
      loopMenuItemRecursively(this.$slots.default, this.$props.selectedKeys, ret);
      return ret.find;
    },
    // isOpen () {
    //   return this.$props.openKeys.indexOf(this.$props.eventKey) !== -1
    // },
    adjustWidth: function adjustWidth() {
      /* istanbul ignore if */
      if (!this.$refs.subMenuTitle || !this.menuInstance) {
        return;
      }

      var popupMenu = this.menuInstance.$el;

      if (popupMenu.offsetWidth >= this.$refs.subMenuTitle.offsetWidth) {
        return;
      }
      /* istanbul ignore next */


      popupMenu.style.minWidth = "".concat(this.$refs.subMenuTitle.offsetWidth, "px");
    },
    renderChildren: function renderChildren(children) {
      var h = this.$createElement;
      var props = this.$props;

      var _getListeners = Object(props_util["getListeners"])(this),
          select = _getListeners.select,
          deselect = _getListeners.deselect,
          openChange = _getListeners.openChange;

      var level = props.level;
      var subPopupMenuProps = {
        props: {
          mode: props.mode === "horizontal" ? "vertical" : level > 2 ? 'vertical' : props.mode,
          visible: props.isOpen,
          level: props.level + 1,
          inlineIndent: props.inlineIndent,
          focusable: false,
          selectedKeys: props.selectedKeys,
          eventKey: "".concat(props.eventKey, "-menu-"),
          openKeys: props.openKeys,
          openTransitionName: props.openTransitionName,
          openAnimation: props.openAnimation,
          subMenuOpenDelay: props.subMenuOpenDelay,
          parentMenu: this,
          subMenuCloseDelay: props.subMenuCloseDelay,
          forceSubMenuRender: props.forceSubMenuRender,
          triggerSubMenuAction: props.triggerSubMenuAction,
          builtinPlacements: props.builtinPlacements,
          defaultActiveFirst: props.store.getState().defaultActiveFirst[getMenuIdFromSubMenuEventKey(props.eventKey)],
          multiple: props.multiple,
          prefixCls: props.rootPrefixCls,
          manualRef: this.saveMenuInstance,
          itemIcon: Object(props_util["getComponentFromProp"])(this, "itemIcon"),
          expandIcon: Object(props_util["getComponentFromProp"])(this, "expandIcon"),
          children: children
        },
        on: {
          click: this.onSubMenuClick,
          select: select,
          deselect: deselect,
          openChange: openChange,
          updateSelectedKeys: this.onUpdateSelectedKeys
        },
        id: this.internalMenuId
      };
      var baseProps = subPopupMenuProps.props;
      var haveRendered = this.haveRendered;
      this.haveRendered = true;
      this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender; // never rendered not planning to, don't render

      if (!this.haveOpened) {
        return h("div");
      } // don't show transition on first rendering (no animation for opened menu)
      // show appear transition if it's not visible (not sure why)
      // show appear transition if it's not inline mode


      var transitionAppear = haveRendered || !baseProps.visible || !baseProps.mode === "inline";
      subPopupMenuProps.class = " ".concat(baseProps.prefixCls, "-sub");
      var animProps = {
        appear: transitionAppear,
        css: false
      };
      var transitionProps = {
        props: animProps,
        on: {}
      };

      if (baseProps.openTransitionName) {
        transitionProps = Object(getTransitionProps["a" /* default */])(baseProps.openTransitionName, {
          appear: transitionAppear
        });
      } else if (SubMenu_typeof(baseProps.openAnimation) === "object") {
        animProps = SubMenu_objectSpread(SubMenu_objectSpread({}, animProps), baseProps.openAnimation.props || {});

        if (!transitionAppear) {
          animProps.appear = false;
        }
      } else if (typeof baseProps.openAnimation === "string") {
        transitionProps = Object(getTransitionProps["a" /* default */])(baseProps.openAnimation, {
          appear: transitionAppear
        });
      }

      if (SubMenu_typeof(baseProps.openAnimation) === "object" && baseProps.openAnimation.on) {
        transitionProps.on = baseProps.openAnimation.on;
      }

      return (// <transition {...transitionProps}>
        h(vc_menu_SubPopupMenu, babel_helper_vue_jsx_merge_props_default()([{
          directives: [{
            name: "show",
            value: props.isOpen
          }]
        }, subPopupMenuProps])) // </transition>

      );
    }
  },
  render: function render() {
    var _className, _attrs;

    var h = arguments[0];
    var props = this.$props;
    var rootPrefixCls = this.rootPrefixCls,
        parentMenu = this.parentMenu;
    var isOpen = props.isOpen;
    var prefixCls = this.getPrefixCls();
    var isInlineMode = props.mode === "inline" && props.level < 2;
    var className = (_className = {}, SubMenu_defineProperty(_className, prefixCls, true), SubMenu_defineProperty(_className, "".concat(prefixCls, "-vertical"), props.mode === 'inline' && props.level > 1), SubMenu_defineProperty(_className, "".concat(prefixCls, "-").concat(props.mode), props.level < 2), SubMenu_defineProperty(_className, this.getOpenClassName(), isOpen), SubMenu_defineProperty(_className, this.getActiveClassName(), props.active || isOpen && !isInlineMode), SubMenu_defineProperty(_className, this.getDisabledClassName(), props.disabled), SubMenu_defineProperty(_className, this.getSelectedClassName(), this.isChildrenSelected()), _className);

    if (!this.internalMenuId) {
      if (props.eventKey) {
        this.internalMenuId = "".concat(props.eventKey, "$Menu");
      } else {
        this.internalMenuId = "$__$".concat(++guid, "$Menu");
      }
    }

    var mouseEvents = {};
    var titleClickEvents = {};
    var titleMouseEvents = {};

    if (!props.disabled) {
      mouseEvents = {
        mouseleave: this.onMouseLeave,
        mouseenter: this.onMouseEnter
      }; // only works in title, not outer li

      titleClickEvents = {
        click: this.onTitleClick
      };
      titleMouseEvents = {
        mouseenter: this.onTitleMouseEnter,
        mouseleave: this.onTitleMouseLeave
      };
    }

    var style = {};

    if (props.mode === 'inline') {
      style.paddingLeft = "".concat(props.inlineIndent * props.level, "px");
    }

    var liDivStyle = {};

    if (props.mode === 'inline' && props.level < 3) {
      liDivStyle.paddingLeft = "".concat(props.inlineIndent * props.level, "px");
    }

    var ariaOwns = {}; // only set aria-owns when menu is open
    // otherwise it would be an invalid aria-owns value
    // since corresponding node cannot be found

    if (isOpen) {
      ariaOwns = {
        "aria-owns": this.internalMenuId
      };
    }

    var titleProps = {
      attrs: SubMenu_objectSpread(SubMenu_objectSpread({
        "aria-expanded": isOpen
      }, ariaOwns), {}, {
        "aria-haspopup": "true",
        title: typeof props.title === "string" ? props.title : undefined
      }),
      on: SubMenu_objectSpread(SubMenu_objectSpread(SubMenu_objectSpread({}, titleMouseEvents), titleClickEvents), {}, {
        updateSelectedKeys: this.onUpdateSelectedKeys
      }),
      style: liDivStyle,
      class: "".concat(prefixCls, "-title"),
      ref: "subMenuTitle"
    }; // expand custom icon should NOT be displayed in menu with horizontal mode.

    var icon = null;
    var defaultIcon = null;

    if (props.mode !== "horizontal") {
      icon = Object(props_util["getComponentFromProp"])(this, "expandIcon", props);
      defaultIcon = h("span", {
        "class": "".concat(prefixCls, "-custom-arrow")
      }, [h("meg-icon", {
        attrs: {
          name: "megui-fill-down",
          width: "18px",
          height: "16px"
        }
      })]);
    }

    var title = h("div", titleProps, [Object(props_util["getComponentFromProp"])(this, "title"), props.showCollapseIcon && icon ? h("div", {
      "class": "".concat(prefixCls, "-custom-arrow")
    }, [icon]) : defaultIcon || h("i", {
      "class": "".concat(prefixCls, "-arrow")
    })]);
    var children = this.renderChildren(Object(props_util["filterEmpty"])(this.$slots.default));
    var getPopupContainer = this.parentMenu.isRootMenu ? this.parentMenu.getPopupContainer : function (triggerNode) {
      return triggerNode.parentNode;
    };
    var popupPlacement = popupPlacementMap[props.mode];
    var popupAlign = props.popupOffset ? {
      offset: props.popupOffset
    } : {};
    var popupClassName = props.mode === "inline" && props.level < 2 ? "" : props.popupClassName;
    var liProps = {
      on: SubMenu_objectSpread(SubMenu_objectSpread({}, Object(es["a" /* default */])(Object(props_util["getListeners"])(this), ["click"])), mouseEvents),
      class: className
    };
    return h("li", babel_helper_vue_jsx_merge_props_default()([liProps, {
      attrs: {
        role: "menuitem"
      }
    }]), [isInlineMode && title, isInlineMode && children, !isInlineMode && h(vc_trigger["a" /* default */], {
      attrs: (_attrs = {
        prefixCls: prefixCls,
        popupClassName: "".concat(prefixCls, "-popup ").concat(rootPrefixCls, "-").concat(parentMenu.theme, " ").concat(popupClassName || ""),
        getPopupContainer: getPopupContainer,
        builtinPlacements: vc_menu_placements
      }, SubMenu_defineProperty(_attrs, "builtinPlacements", Object.assign({}, vc_menu_placements, props.builtinPlacements)), SubMenu_defineProperty(_attrs, "popupPlacement", popupPlacement), SubMenu_defineProperty(_attrs, "popupVisible", isOpen), SubMenu_defineProperty(_attrs, "popupAlign", popupAlign), SubMenu_defineProperty(_attrs, "action", props.disabled ? [] : props.level > 1 ? ['hover'] : [props.triggerSubMenuAction]), SubMenu_defineProperty(_attrs, "mouseEnterDelay", props.subMenuOpenDelay), SubMenu_defineProperty(_attrs, "mouseLeaveDelay", props.subMenuCloseDelay), SubMenu_defineProperty(_attrs, "forceRender", props.forceSubMenuRender), _attrs),
      on: {
        "popupVisibleChange": this.onPopupVisibleChange
      }
    }, [h("template", {
      slot: "popup"
    }, [children]), title])]);
  }
};
var connected = Object(utils_store["b" /* connect */])(function (_ref, _ref2) {
  var openKeys = _ref.openKeys,
      activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    isOpen: openKeys.indexOf(eventKey) > -1,
    active: activeKey[subMenuKey] === eventKey,
    selectedKeys: selectedKeys
  };
})(SubMenu);
connected.isSubMenu = true;
/* harmony default export */ var vc_menu_SubMenu = (connected);
// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// CONCATENATED MODULE: ./src/base/vc-menu/DOMWrap.jsx
var _excluded = ["title"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || DOMWrap_unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function DOMWrap_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return DOMWrap_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DOMWrap_arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return DOMWrap_arrayLikeToArray(arr); }

function DOMWrap_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function DOMWrap_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function DOMWrap_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DOMWrap_ownKeys(Object(source), true).forEach(function (key) { DOMWrap_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DOMWrap_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function DOMWrap_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
var FLOAT_PRECISION_ADJUST = 0.5; // Fix ssr

if (canUseDOM) {
  __webpack_require__(338);
}

var DOMWrap = {
  name: 'DOMWrap',
  mixins: [BaseMixin["a" /* default */]],
  data: function data() {
    this.resizeObserver = null;
    this.mutationObserver = null; // original scroll size of the list

    this.originalTotalWidth = 0; // copy of overflowed items

    this.overflowedItems = []; // cache item of the original items (so we can track the size and order)

    this.menuItemSizes = [];
    return {
      lastVisibleIndex: undefined
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.setChildrenWidthAndResize();

      if (_this.level === 1 && _this.mode === 'horizontal') {
        var menuUl = _this.$el;

        if (!menuUl) {
          return;
        }

        _this.resizeObserver = new ResizeObserver_es["a" /* default */](function (entries) {
          entries.forEach(_this.setChildrenWidthAndResize);
        });
        [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
          _this.resizeObserver.observe(el);
        });

        if (typeof MutationObserver !== 'undefined') {
          _this.mutationObserver = new MutationObserver(function () {
            _this.resizeObserver.disconnect();

            [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
              _this.resizeObserver.observe(el);
            });

            _this.setChildrenWidthAndResize();
          });

          _this.mutationObserver.observe(menuUl, {
            attributes: false,
            childList: true,
            subTree: false
          });
        }
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  },
  methods: {
    // get all valid menuItem nodes
    getMenuItemNodes: function getMenuItemNodes() {
      var prefixCls = this.$props.prefixCls;
      var ul = this.$el;

      if (!ul) {
        return [];
      } // filter out all overflowed indicator placeholder


      return [].slice.call(ul.children).filter(function (node) {
        return node.className.split(' ').indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
      });
    },
    getOverflowedSubMenuItem: function getOverflowedSubMenuItem(keyPrefix, overflowedItems, renderPlaceholder) {
      var h = this.$createElement;
      var _this$$props = this.$props,
          overflowedIndicator = _this$$props.overflowedIndicator,
          level = _this$$props.level,
          mode = _this$$props.mode,
          prefixCls = _this$$props.prefixCls,
          theme = _this$$props.theme;

      if (level !== 1 || mode !== 'horizontal') {
        return null;
      } // put all the overflowed item inside a submenu
      // with a title of overflow indicator ('...')


      var copy = this.$slots.default[0];

      var _getPropsData = Object(props_util["getPropsData"])(copy),
          title = _getPropsData.title,
          rest = _objectWithoutProperties(_getPropsData, _excluded); // eslint-disable-line no-unused-vars


      var events = Object(props_util["getEvents"])(copy);
      var style = {};
      var key = "".concat(keyPrefix, "-overflowed-indicator");
      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");

      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
        style = {
          display: 'none'
        };
      } else if (renderPlaceholder) {
        style = {
          visibility: 'hidden',
          // prevent from taking normal dom space
          position: 'absolute'
        };
        key = "".concat(key, "-placeholder");
        eventKey = "".concat(eventKey, "-placeholder");
      }

      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : '';
      var props = {};
      var on = {};
      menuAllProps.props.forEach(function (k) {
        if (rest[k] !== undefined) {
          props[k] = rest[k];
        }
      });
      menuAllProps.on.forEach(function (k) {
        if (events[k] !== undefined) {
          on[k] = events[k];
        }
      });
      var subMenuProps = {
        props: DOMWrap_objectSpread(DOMWrap_objectSpread({
          title: overflowedIndicator,
          popupClassName: popupClassName
        }, props), {}, {
          eventKey: eventKey,
          disabled: false
        }),
        class: "".concat(prefixCls, "-overflowed-submenu"),
        key: key,
        style: style,
        on: on
      };
      return h(vc_menu_SubMenu, subMenuProps, [overflowedItems]);
    },
    // memorize rendered menuSize
    setChildrenWidthAndResize: function setChildrenWidthAndResize() {
      if (this.mode !== 'horizontal') {
        return;
      }

      var ul = this.$el;

      if (!ul) {
        return;
      }

      var ulChildrenNodes = ul.children;

      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
        return;
      }

      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1]; // need last overflowed indicator for calculating length;

      setStyle(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');
      var menuItemNodes = this.getMenuItemNodes(); // reset display attribute for all hidden elements caused by overflow to calculate updated width
      // and then reset to original state after width calculation

      var overflowedItems = menuItemNodes.filter(function (c) {
        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
      });
      overflowedItems.forEach(function (c) {
        setStyle(c, 'display', 'inline-block');
      });
      this.menuItemSizes = menuItemNodes.map(function (c) {
        return getWidth(c);
      });
      overflowedItems.forEach(function (c) {
        setStyle(c, 'display', 'none');
      });
      this.overflowedIndicatorWidth = getWidth(ul.children[ul.children.length - 1]);
      this.originalTotalWidth = this.menuItemSizes.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
      this.handleResize(); // prevent the overflowed indicator from taking space;

      setStyle(lastOverflowedIndicatorPlaceholder, 'display', 'none');
    },
    handleResize: function handleResize() {
      var _this2 = this;

      if (this.mode !== 'horizontal') {
        return;
      }

      var ul = this.$el;

      if (!ul) {
        return;
      }

      var width = getWidth(ul);
      this.overflowedItems = [];
      var currentSumWidth = 0; // index for last visible child in horizontal mode

      var lastVisibleIndex; // float number comparison could be problematic
      // e.g. 0.1 + 0.2 > 0.3 =====> true
      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation

      if (this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
        lastVisibleIndex = -1;
        this.menuItemSizes.forEach(function (liWidth) {
          currentSumWidth += liWidth;

          if (currentSumWidth + _this2.overflowedIndicatorWidth <= width) {
            lastVisibleIndex += 1;
          }
        });
      }

      this.setState({
        lastVisibleIndex: lastVisibleIndex
      });
    },
    renderChildren: function renderChildren(children) {
      var _this3 = this;

      // need to take care of overflowed items in horizontal mode
      var lastVisibleIndex = this.$data.lastVisibleIndex;
      var className = Object(props_util["getClass"])(this);
      return (children || []).reduce(function (acc, childNode, index) {
        var item = childNode;
        var eventKey = Object(props_util["getPropsData"])(childNode).eventKey;

        if (_this3.mode === 'horizontal') {
          var overflowed = _this3.getOverflowedSubMenuItem(eventKey, []);

          if (lastVisibleIndex !== undefined && className["".concat(_this3.prefixCls, "-root")] !== -1) {
            if (index > lastVisibleIndex) {
              item = Object(vnode["a" /* cloneElement */])(childNode, // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
              {
                style: {
                  display: 'none'
                },
                props: {
                  eventKey: "".concat(eventKey, "-hidden")
                },
                class: MENUITEM_OVERFLOWED_CLASSNAME
              });
            }

            if (index === lastVisibleIndex + 1) {
              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
                return Object(vnode["a" /* cloneElement */])(c, // children[index].key will become '.$key' in clone by default,
                // we have to overwrite with the correct key explicitly
                {
                  key: Object(props_util["getPropsData"])(c).eventKey,
                  props: {
                    mode: 'vertical-left'
                  }
                });
              });
              overflowed = _this3.getOverflowedSubMenuItem(eventKey, _this3.overflowedItems);
            }
          }

          var ret = [].concat(_toConsumableArray(acc), [overflowed, item]);

          if (index === children.length - 1) {
            // need a placeholder for calculating overflowed indicator width
            ret.push(_this3.getOverflowedSubMenuItem(eventKey, [], true));
          }

          return ret;
        }

        return [].concat(_toConsumableArray(acc), [item]);
      }, []);
    }
  },
  render: function render() {
    var h = arguments[0];
    var Tag = this.$props.tag;
    var tagProps = {
      on: Object(props_util["getListeners"])(this)
    };
    return h(Tag, tagProps, [this.renderChildren(this.$slots.default)]);
  }
};
DOMWrap.props = {
  mode: vue_types["a" /* default */].oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
  prefixCls: vue_types["a" /* default */].string,
  level: vue_types["a" /* default */].number,
  theme: vue_types["a" /* default */].string,
  overflowedIndicator: vue_types["a" /* default */].node,
  visible: vue_types["a" /* default */].bool,
  hiddenClassName: vue_types["a" /* default */].string,
  tag: vue_types["a" /* default */].string.def('div')
};
/* harmony default export */ var vc_menu_DOMWrap = (DOMWrap);
// CONCATENATED MODULE: ./src/base/vc-menu/SubPopupMenu.jsx
function SubPopupMenu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SubPopupMenu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SubPopupMenu_ownKeys(Object(source), true).forEach(function (key) { SubPopupMenu_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SubPopupMenu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SubPopupMenu_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












function allDisabled(arr) {
  if (!arr.length) {
    return true;
  }

  return arr.every(function (c) {
    return !!c.disabled;
  });
}

function updateActiveKey(store, menuId, activeKey) {
  var state = store.getState();
  store.setState({
    activeKey: SubPopupMenu_objectSpread(SubPopupMenu_objectSpread({}, state.activeKey), {}, SubPopupMenu_defineProperty({}, menuId, activeKey))
  });
}

function getEventKey(props) {
  // when eventKey not available ,it's menu and return menu id '0-menu-'
  return props.eventKey || '0-menu-';
}

function saveRef(key, c) {
  if (c) {
    var index = this.instanceArrayKeyIndexMap[key];
    this.instanceArray[index] = c;
  }
}
function getActiveKey(props, originalActiveKey) {
  var activeKey = originalActiveKey;
  var eventKey = props.eventKey,
      defaultActiveFirst = props.defaultActiveFirst,
      children = props.children;

  if (activeKey !== undefined && activeKey !== null) {
    var found;
    loopMenuItem(children, function (c, i) {
      var propsData = c.componentOptions.propsData || {};

      if (c && !propsData.disabled && activeKey === getKeyFromChildrenIndex(c, eventKey, i)) {
        found = true;
      }
    });

    if (found) {
      return activeKey;
    }
  }

  activeKey = null;

  if (defaultActiveFirst) {
    loopMenuItem(children, function (c, i) {
      var propsData = c.componentOptions.propsData || {};
      var noActiveKey = activeKey === null || activeKey === undefined;

      if (noActiveKey && c && !propsData.disabled) {
        activeKey = getKeyFromChildrenIndex(c, eventKey, i);
      }
    });
    return activeKey;
  }

  return activeKey;
}
var SubPopupMenu = {
  name: 'SubPopupMenu',
  props: Object(props_util["initDefaultProps"])({
    // onSelect: PropTypes.func,
    // onClick: PropTypes.func,
    // onDeselect: PropTypes.func,
    // onOpenChange: PropTypes.func,
    // onDestroy: PropTypes.func,
    prefixCls: vue_types["a" /* default */].string,
    openTransitionName: vue_types["a" /* default */].string,
    openAnimation: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].object]),
    openKeys: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])),
    visible: vue_types["a" /* default */].bool,
    parentMenu: vue_types["a" /* default */].object,
    eventKey: vue_types["a" /* default */].string,
    store: vue_types["a" /* default */].object,
    // adding in refactor
    focusable: vue_types["a" /* default */].bool,
    multiple: vue_types["a" /* default */].bool,
    defaultActiveFirst: vue_types["a" /* default */].bool,
    activeKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    selectedKeys: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])),
    defaultSelectedKeys: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])),
    defaultOpenKeys: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])),
    level: vue_types["a" /* default */].number,
    mode: vue_types["a" /* default */].oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
    triggerSubMenuAction: vue_types["a" /* default */].oneOf(['click', 'hover']),
    inlineIndent: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].number, vue_types["a" /* default */].string]),
    manualRef: vue_types["a" /* default */].func,
    itemIcon: vue_types["a" /* default */].any,
    expandIcon: vue_types["a" /* default */].any,
    overflowedIndicator: vue_types["a" /* default */].any,
    children: vue_types["a" /* default */].any.def([]),
    __propsSymbol__: vue_types["a" /* default */].any // mock componentWillReceiveProps

  }, {
    prefixCls: 'rc-menu',
    mode: 'vertical',
    level: 1,
    inlineIndent: 24,
    visible: true,
    focusable: true,
    manualRef: noop
  }),
  mixins: [BaseMixin["a" /* default */]],
  created: function created() {
    var props = Object(props_util["getOptionProps"])(this);
    this.prevProps = SubPopupMenu_objectSpread({}, props);
    props.store.setState({
      activeKey: SubPopupMenu_objectSpread(SubPopupMenu_objectSpread({}, props.store.getState().activeKey), {}, SubPopupMenu_defineProperty({}, props.eventKey, getActiveKey(props, props.activeKey)))
    });
    this.instanceArray = [];
  },
  mounted: function mounted() {
    // invoke customized ref to expose component to mixin
    if (this.manualRef) {
      this.manualRef(this);
    }
  },
  updated: function updated() {
    var props = Object(props_util["getOptionProps"])(this);
    var prevProps = this.prevProps;
    var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
    var activeKey = getActiveKey(props, originalActiveKey);

    if (activeKey !== originalActiveKey) {
      updateActiveKey(props.store, getEventKey(props), activeKey);
    } else if ('activeKey' in prevProps) {
      // If prev activeKey is not same as current activeKey,
      // we should set it.
      var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);

      if (activeKey !== prevActiveKey) {
        updateActiveKey(props.store, getEventKey(props), activeKey);
      }
    }

    this.prevProps = SubPopupMenu_objectSpread({}, props);
  },
  methods: {
    // all keyboard events callbacks run from here at first
    onKeyDown: function onKeyDown(e, callback) {
      var keyCode = e.keyCode;
      var handled;
      this.getFlatInstanceArray().forEach(function (obj) {
        if (obj && obj.active && obj.onKeyDown) {
          handled = obj.onKeyDown(e);
        }
      });

      if (handled) {
        return 1;
      }

      var activeItem = null;

      if (keyCode === key_code["a" /* default */].UP || keyCode === key_code["a" /* default */].DOWN) {
        activeItem = this.step(keyCode === key_code["a" /* default */].UP ? -1 : 1);
      }

      if (activeItem) {
        e.preventDefault();
        updateActiveKey(this.$props.store, getEventKey(this.$props), activeItem.eventKey);

        if (typeof callback === 'function') {
          callback(activeItem);
        }

        return 1;
      }

      return undefined;
    },
    onItemHover: function onItemHover(e) {
      var key = e.key,
          hover = e.hover;
      updateActiveKey(this.$props.store, getEventKey(this.$props), hover ? key : null);
    },
    onUpdateSelectedKeys: function onUpdateSelectedKeys(e) {
      this.__emit('updateSelectedKeys', e);
    },
    onDeselect: function onDeselect(selectInfo) {
      this.__emit('deselect', selectInfo);
    },
    onSelect: function onSelect(selectInfo) {
      this.__emit('select', selectInfo);
    },
    onClick: function onClick(e) {
      this.__emit('click', e);
    },
    onOpenChange: function onOpenChange(e) {
      this.__emit('openChange', e);
    },
    onDestroy: function onDestroy(key) {
      this.__emit('destroy', key);
    },
    getFlatInstanceArray: function getFlatInstanceArray() {
      return this.instanceArray;
    },
    getOpenTransitionName: function getOpenTransitionName() {
      return this.$props.openTransitionName;
    },
    step: function step(direction) {
      var children = this.getFlatInstanceArray();
      var activeKey = this.$props.store.getState().activeKey[getEventKey(this.$props)];
      var len = children.length;

      if (!len) {
        return null;
      }

      if (direction < 0) {
        children = children.concat().reverse();
      } // find current activeIndex


      var activeIndex = -1;
      children.every(function (c, ci) {
        if (c && c.eventKey === activeKey) {
          activeIndex = ci;
          return false;
        }

        return true;
      });

      if (!this.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
        return undefined;
      }

      var start = (activeIndex + 1) % len;
      var i = start;

      do {
        var child = children[i];

        if (!child || child.disabled) {
          i = (i + 1) % len;
        } else {
          return child;
        }
      } while (i !== start);

      return null;
    },
    getIcon: function getIcon(instance, name) {
      if (instance.$createElement) {
        var temp = instance[name];

        if (temp !== undefined) {
          return temp;
        }

        return instance.$slots[name] || instance.$scopedSlots[name];
      } else {
        var _temp = Object(props_util["getPropsData"])(instance)[name];

        if (_temp !== undefined) {
          return _temp;
        }

        var slotsProp = [];
        var componentOptions = instance.componentOptions || {};
        (componentOptions.children || []).forEach(function (child) {
          if (child.data && child.data.slot === name) {
            if (child.tag === 'template') {
              slotsProp.push(child.children);
            } else {
              slotsProp.push(child);
            }
          }
        });
        return slotsProp.length ? slotsProp : undefined;
      }
    },
    renderCommonMenuItem: function renderCommonMenuItem(child, i, extraProps) {
      var _this = this;

      if (child.tag === undefined) {
        return child;
      }

      var state = this.$props.store.getState();
      var props = this.$props;
      var key = getKeyFromChildrenIndex(child, props.eventKey, i);
      var childProps = child.componentOptions.propsData || {};
      var isActive = key === state.activeKey[getEventKey(this.$props)];

      if (!childProps.disabled) {
        // manualRef的执行顺序不能保证，使用key映射ref在this.instanceArray中的位置
        this.instanceArrayKeyIndexMap[key] = Object.keys(this.instanceArrayKeyIndexMap).length;
      }

      var childListeners = Object(props_util["getEvents"])(child);
      var newChildProps = {
        props: SubPopupMenu_objectSpread({
          mode: childProps.mode || props.mode,
          level: props.level,
          inlineIndent: props.inlineIndent,
          renderMenuItem: this.renderMenuItem,
          rootPrefixCls: props.prefixCls,
          index: i,
          parentMenu: props.parentMenu,
          // customized ref function, need to be invoked manually in child's componentDidMount
          manualRef: childProps.disabled ? noop : saveRef.bind(this, key),
          eventKey: key,
          active: !childProps.disabled && isActive,
          multiple: props.multiple,
          openTransitionName: this.getOpenTransitionName(),
          openAnimation: props.openAnimation,
          subMenuOpenDelay: props.subMenuOpenDelay,
          subMenuCloseDelay: props.subMenuCloseDelay,
          forceSubMenuRender: props.forceSubMenuRender,
          builtinPlacements: props.builtinPlacements,
          itemIcon: this.getIcon(child, 'itemIcon') || this.getIcon(this, 'itemIcon'),
          expandIcon: this.getIcon(child, 'expandIcon') || this.getIcon(this, 'expandIcon')
        }, extraProps),
        on: {
          click: function click(e) {
            (childListeners.click || noop)(e);

            _this.onClick(e);
          },
          itemHover: this.onItemHover,
          openChange: this.onOpenChange,
          deselect: this.onDeselect,
          // destroy: this.onDestroy,
          select: this.onSelect,
          updateSelectedKeys: this.onUpdateSelectedKeys
        }
      }; // ref: https://github.com/ant-design/ant-design/issues/13943

      if (props.mode === 'inline' && props.level < 2 || util_isMobileDevice()) {
        newChildProps.props.triggerSubMenuAction = 'click';
      }

      return Object(vnode["a" /* cloneElement */])(child, newChildProps);
    },
    renderMenuItem: function renderMenuItem(c, i, subMenuKey) {
      if (!c) {
        return null;
      }

      var state = this.$props.store.getState();
      var extraProps = {
        openKeys: state.openKeys,
        selectedKeys: state.selectedKeys,
        triggerSubMenuAction: this.triggerSubMenuAction,
        isRootMenu: false,
        subMenuKey: subMenuKey
      };
      return this.renderCommonMenuItem(c, i, extraProps);
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var props = Object.assign({}, this.$props);
    var eventKey = props.eventKey,
        prefixCls = props.prefixCls,
        visible = props.visible,
        level = props.level,
        mode = props.mode,
        theme = props.theme;
    this.instanceArray = [];
    this.instanceArrayKeyIndexMap = {}; // 支持inline模式下，三级菜单hover出现

    var className = external_classnames_default()(props.prefixCls, level > 2 && props.mode === 'inline' ? "".concat(props.prefixCls, "-vertical") : "".concat(props.prefixCls, "-").concat(props.mode));
    var domWrapProps = {
      props: {
        tag: 'ul',
        // hiddenClassName: `${prefixCls}-hidden`,
        visible: visible,
        prefixCls: prefixCls,
        level: level,
        mode: mode,
        theme: theme,
        overflowedIndicator: Object(props_util["getComponentFromProp"])(this, 'overflowedIndicator')
      },
      attrs: {
        role: props.role || 'menu'
      },
      class: className,
      // Otherwise, the propagated click event will trigger another onClick
      on: Object(es["a" /* default */])(Object(props_util["getListeners"])(this), ['click'])
    }; // if (props.id) {
    //   domProps.id = props.id
    // }

    if (props.focusable) {
      domWrapProps.attrs.tabIndex = '0';
      domWrapProps.on.keydown = this.onKeyDown;
    }

    return (// ESLint is not smart enough to know that the type of `children` was checked.

      /* eslint-disable */
      h(vc_menu_DOMWrap, domWrapProps, [props.children.map(function (c, i) {
        return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
      })])
      /*eslint -enable */

    );
  }
};
/* harmony default export */ var vc_menu_SubPopupMenu = (Object(utils_store["b" /* connect */])()(SubPopupMenu));
// EXTERNAL MODULE: ./src/base/vc-menu/commonPropsType.js
var commonPropsType = __webpack_require__(101);

// CONCATENATED MODULE: ./src/base/vc-menu/Menu.jsx
function Menu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Menu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Menu_ownKeys(Object(source), true).forEach(function (key) { Menu_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Menu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Menu_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var Menu = {
  name: 'Menu',
  props: Menu_objectSpread(Menu_objectSpread({}, commonPropsType["a" /* default */]), {}, {
    selectable: vue_types["a" /* default */].bool.def(true)
  }),
  mixins: [BaseMixin["a" /* default */]],
  data: function data() {
    var props = Object(props_util["getOptionProps"])(this);
    var selectedKeys = props.defaultSelectedKeys;
    var openKeys = props.defaultOpenKeys;

    if ('selectedKeys' in props) {
      selectedKeys = props.selectedKeys || [];
    }

    if ('openKeys' in props) {
      openKeys = props.openKeys || [];
    }

    this.store = Object(utils_store["c" /* create */])({
      selectedKeys: selectedKeys,
      openKeys: openKeys,
      activeKey: {
        '0-menu-': getActiveKey(Menu_objectSpread(Menu_objectSpread({}, props), {}, {
          children: this.$slots.default || []
        }), props.activeKey)
      }
    }); // this.isRootMenu = true // 声明在props上

    return {};
  },
  mounted: function mounted() {
    this.updateMiniStore();
  },
  updated: function updated() {
    this.updateMiniStore();
  },
  methods: {
    onSelect: function onSelect(selectInfo) {
      var props = this.$props;

      if (props.selectable) {
        // root menu
        var selectedKeys = this.store.getState().selectedKeys;
        var selectedKey = selectInfo.key;

        if (props.multiple) {
          selectedKeys = selectedKeys.concat([selectedKey]);
        } else {
          selectedKeys = [selectedKey];
        }

        if (!Object(props_util["default"])(this, 'selectedKeys')) {
          this.store.setState({
            selectedKeys: selectedKeys
          });
        }

        this.__emit('select', Menu_objectSpread(Menu_objectSpread({}, selectInfo), {}, {
          selectedKeys: selectedKeys
        }));
      }
    },
    onClick: function onClick(e) {
      this.__emit('click', e);
    },
    // onKeyDown needs to be exposed as a instance method
    // e.g., in rc-select, we need to navigate menu item while
    // current active item is rc-select input box rather than the menu itself
    onKeyDown: function onKeyDown(e, callback) {
      this.$refs.innerMenu.getWrappedInstance().onKeyDown(e, callback);
    },
    onOpenChange: function onOpenChange(event) {
      var openKeys = this.store.getState().openKeys.concat();
      var changed = false;

      var processSingle = function processSingle(e) {
        var oneChanged = false;

        if (e.open) {
          oneChanged = openKeys.indexOf(e.key) === -1;

          if (oneChanged) {
            openKeys.push(e.key);
          }
        } else {
          var index = openKeys.indexOf(e.key);
          oneChanged = index !== -1;

          if (oneChanged) {
            openKeys.splice(index, 1);
          }
        }

        changed = changed || oneChanged;
      };

      if (Array.isArray(event)) {
        // batch change call
        event.forEach(processSingle);
      } else {
        processSingle(event);
      }

      if (changed) {
        if (!Object(props_util["default"])(this, 'openKeys')) {
          this.store.setState({
            openKeys: openKeys
          });
        }

        this.__emit('openChange', openKeys);
      }
    },
    onDeselect: function onDeselect(selectInfo) {
      var props = this.$props;

      if (props.selectable) {
        var selectedKeys = this.store.getState().selectedKeys.concat();
        var selectedKey = selectInfo.key;
        var index = selectedKeys.indexOf(selectedKey);

        if (index !== -1) {
          selectedKeys.splice(index, 1);
        }

        if (!Object(props_util["default"])(this, 'selectedKeys')) {
          this.store.setState({
            selectedKeys: selectedKeys
          });
        }

        this.__emit('deselect', Menu_objectSpread(Menu_objectSpread({}, selectInfo), {}, {
          selectedKeys: selectedKeys
        }));
      }
    },
    onUpdateSelectedKeys: function onUpdateSelectedKeys(e) {
      this.__emit('updateSelectedKeys', e);
    },
    getOpenTransitionName: function getOpenTransitionName() {
      var props = this.$props;
      var transitionName = props.openTransitionName;
      var animationName = props.openAnimation;

      if (!transitionName && typeof animationName === 'string') {
        transitionName = "".concat(props.prefixCls, "-open-").concat(animationName);
      }

      return transitionName;
    },
    updateMiniStore: function updateMiniStore() {
      var props = Object(props_util["getOptionProps"])(this);

      if ('selectedKeys' in props) {
        this.store.setState({
          selectedKeys: props.selectedKeys || []
        });
      }

      if ('openKeys' in props) {
        this.store.setState({
          openKeys: props.openKeys || []
        });
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var subPopupMenuProps = {
      props: Menu_objectSpread(Menu_objectSpread({}, props), {}, {
        itemIcon: Object(props_util["getComponentFromProp"])(this, 'itemIcon', props),
        expandIcon: Object(props_util["getComponentFromProp"])(this, 'expandIcon', props),
        overflowedIndicator: Object(props_util["getComponentFromProp"])(this, 'overflowedIndicator', props) || h("span", ["\xB7\xB7\xB7"]),
        openTransitionName: this.getOpenTransitionName(),
        parentMenu: this,
        children: Object(props_util["filterEmpty"])(this.$slots.default || [])
      }),
      class: "".concat(props.prefixCls, "-root"),
      on: Menu_objectSpread(Menu_objectSpread({}, Object(props_util["getListeners"])(this)), {}, {
        click: this.onClick,
        openChange: this.onOpenChange,
        deselect: this.onDeselect,
        select: this.onSelect,
        updateSelectedKeys: this.onUpdateSelectedKeys
      }),
      ref: 'innerMenu'
    };
    return h(utils_store["a" /* Provider */], {
      attrs: {
        store: this.store
      }
    }, [h(vc_menu_SubPopupMenu, subPopupMenuProps)]);
  }
};
/* harmony default export */ var vc_menu_Menu = (Menu);
// EXTERNAL MODULE: ./node_modules/dom-scroll-into-view/dist-web/index.js
var dist_web = __webpack_require__(69);

// CONCATENATED MODULE: ./src/base/vc-menu/MenuItem.jsx


function MenuItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MenuItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MenuItem_ownKeys(Object(source), true).forEach(function (key) { MenuItem_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MenuItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function MenuItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var MenuItem_props = {
  attribute: vue_types["a" /* default */].object,
  rootPrefixCls: vue_types["a" /* default */].string,
  eventKey: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
  active: vue_types["a" /* default */].bool,
  selectedKeys: vue_types["a" /* default */].array,
  disabled: vue_types["a" /* default */].bool,
  title: vue_types["a" /* default */].any,
  index: vue_types["a" /* default */].number,
  inlineIndent: vue_types["a" /* default */].number.def(24),
  level: vue_types["a" /* default */].number.def(1),
  mode: vue_types["a" /* default */].oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']).def('vertical'),
  parentMenu: vue_types["a" /* default */].object,
  multiple: vue_types["a" /* default */].bool,
  value: vue_types["a" /* default */].any,
  isSelected: vue_types["a" /* default */].bool,
  manualRef: vue_types["a" /* default */].func.def(noop),
  role: vue_types["a" /* default */].any,
  subMenuKey: vue_types["a" /* default */].string,
  itemIcon: vue_types["a" /* default */].any,
  originalData: vue_types["a" /* default */].object // 新加属性,用于外部透传自定义数据
  // clearSubMenuTimers: PropTypes.func.def(noop),

};
var MenuItem = {
  name: 'MenuItem',
  props: MenuItem_props,
  mixins: [BaseMixin["a" /* default */]],
  isMenuItem: true,
  created: function created() {
    this.prevActive = this.active; // invoke customized ref to expose component to mixin

    this.callRef();
  },
  updated: function updated() {
    var _this = this;

    if (this.$props.isSelected === true && this.$props.active === this.prevActive) {
      var _this$$props = this.$props,
          eventKey = _this$$props.eventKey,
          active = _this$$props.active;
      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: this,
        domEvent: this.$el,
        originalData: this.originalData
      };

      this.__emit('updateSelectedKeys', info);
    }

    this.$nextTick(function () {
      var _this$$props2 = _this.$props,
          active = _this$$props2.active,
          parentMenu = _this$$props2.parentMenu,
          eventKey = _this$$props2.eventKey;

      if (!_this.prevActive && active && (!parentMenu || !parentMenu["scrolled-".concat(eventKey)])) {
        Object(dist_web["a" /* default */])(_this.$el, _this.parentMenu.$el, {
          onlyScrollIfNeeded: true
        });
        parentMenu["scrolled-".concat(eventKey)] = true;
      } else if (parentMenu && parentMenu["scrolled-".concat(eventKey)]) {
        delete parentMenu["scrolled-".concat(eventKey)];
      }

      _this.prevActive = active;
    });
    this.callRef();
  },
  beforeDestroy: function beforeDestroy() {
    var props = this.$props;

    this.__emit('destroy', props.eventKey);
  },
  methods: {
    onKeyDown: function onKeyDown(e) {
      var keyCode = e.keyCode;

      if (keyCode === key_code["a" /* default */].ENTER) {
        this.onClick(e);
        return true;
      }
    },
    onMouseLeave: function onMouseLeave(e) {
      var eventKey = this.$props.eventKey;

      this.__emit('itemHover', {
        key: eventKey,
        hover: false
      });

      this.__emit('mouseleave', {
        key: eventKey,
        domEvent: e
      });
    },
    onMouseEnter: function onMouseEnter(e) {
      var eventKey = this.eventKey;

      this.__emit('itemHover', {
        key: eventKey,
        hover: true
      });

      this.__emit('mouseenter', {
        key: eventKey,
        domEvent: e
      });
    },
    onClick: function onClick(e) {
      var _this$$props3 = this.$props,
          eventKey = _this$$props3.eventKey,
          multiple = _this$$props3.multiple,
          isSelected = _this$$props3.isSelected;
      var info = {
        key: eventKey,
        keyPath: [eventKey],
        item: this,
        domEvent: e,
        originalData: this.originalData
      };

      this.__emit('click', info);

      if (multiple) {
        if (isSelected) {
          this.__emit('deselect', info);
        } else {
          this.__emit('select', info);
        }
      } else if (!isSelected) {
        this.__emit('select', info);
      }
    },
    getPrefixCls: function getPrefixCls() {
      return "".concat(this.$props.rootPrefixCls, "-item");
    },
    getActiveClassName: function getActiveClassName() {
      return "".concat(this.getPrefixCls(), "-active");
    },
    getSelectedClassName: function getSelectedClassName() {
      return "".concat(this.getPrefixCls(), "-selected");
    },
    getDisabledClassName: function getDisabledClassName() {
      return "".concat(this.getPrefixCls(), "-disabled");
    },
    callRef: function callRef() {
      if (this.manualRef) {
        this.manualRef(this);
      }
    }
  },
  render: function render() {
    var _className;

    var h = arguments[0];

    var props = MenuItem_objectSpread({}, this.$props);

    var className = (_className = {}, MenuItem_defineProperty(_className, this.getPrefixCls(), true), MenuItem_defineProperty(_className, this.getActiveClassName(), !props.disabled && props.active), MenuItem_defineProperty(_className, this.getSelectedClassName(), props.isSelected), MenuItem_defineProperty(_className, this.getDisabledClassName(), props.disabled), _className);

    var attrs = MenuItem_objectSpread(MenuItem_objectSpread({}, props.attribute), {}, {
      title: props.title,
      role: props.role || 'menuitem',
      'aria-disabled': props.disabled
    });

    if (props.role === 'option') {
      // overwrite to option
      attrs = MenuItem_objectSpread(MenuItem_objectSpread({}, attrs), {}, {
        role: 'option',
        'aria-selected': props.isSelected
      });
    } else if (props.role === null || props.role === 'none') {
      // sometimes we want to specify role inside <li/> element
      // <li><a role='menuitem'>Link</a></li> would be a good example
      // in this case the role on <li/> should be "none" to
      // remove the implied listitem role.
      // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
      attrs.role = 'none';
    } // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner


    var mouseEvent = {
      click: props.disabled ? noop : this.onClick,
      mouseleave: props.disabled ? noop : this.onMouseLeave,
      mouseenter: props.disabled ? noop : this.onMouseEnter
    };
    var style = {};

    if (props.mode === 'inline' && props.level < 3) {
      // 三级菜单不需要 paddingLeft
      style.paddingLeft = "".concat(props.inlineIndent * props.level, "px");
    }

    var listeners = MenuItem_objectSpread({}, Object(props_util["getListeners"])(this));

    menuAllProps.props.forEach(function (key) {
      return delete props[key];
    });
    menuAllProps.on.forEach(function (key) {
      return delete listeners[key];
    });
    var liProps = {
      attrs: MenuItem_objectSpread(MenuItem_objectSpread({}, props), attrs),
      on: MenuItem_objectSpread(MenuItem_objectSpread({}, listeners), mouseEvent)
    };
    return h("li", babel_helper_vue_jsx_merge_props_default()([liProps, {
      style: style,
      "class": className
    }]), [this.$slots.default, Object(props_util["getComponentFromProp"])(this, 'itemIcon', props)]);
  }
};
var MenuItem_connected = Object(utils_store["b" /* connect */])(function (_ref, _ref2) {
  var activeKey = _ref.activeKey,
      selectedKeys = _ref.selectedKeys;
  var eventKey = _ref2.eventKey,
      subMenuKey = _ref2.subMenuKey;
  return {
    active: activeKey[subMenuKey] === eventKey,
    isSelected: selectedKeys.indexOf(eventKey) !== -1
  };
})(MenuItem);
/* harmony default export */ var vc_menu_MenuItem = (MenuItem_connected);

// CONCATENATED MODULE: ./src/base/vc-menu/MenuItemGroup.jsx
function MenuItemGroup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MenuItemGroup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MenuItemGroup_ownKeys(Object(source), true).forEach(function (key) { MenuItemGroup_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MenuItemGroup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function MenuItemGroup_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // import { menuAllProps } from './util'

var MenuItemGroup = {
  name: 'MenuItemGroup',
  props: {
    renderMenuItem: vue_types["a" /* default */].func,
    index: vue_types["a" /* default */].number,
    className: vue_types["a" /* default */].string,
    subMenuKey: vue_types["a" /* default */].string,
    rootPrefixCls: vue_types["a" /* default */].string,
    disabled: vue_types["a" /* default */].bool.def(true),
    title: vue_types["a" /* default */].any
  },
  isMenuItemGroup: true,
  methods: {
    renderInnerMenuItem: function renderInnerMenuItem(item) {
      var _this$$props = this.$props,
          renderMenuItem = _this$$props.renderMenuItem,
          index = _this$$props.index,
          subMenuKey = _this$$props.subMenuKey;
      return renderMenuItem(item, index, subMenuKey);
    }
  },
  render: function render() {
    var h = arguments[0];

    var props = MenuItemGroup_objectSpread({}, this.$props);

    var rootPrefixCls = props.rootPrefixCls,
        title = props.title;
    var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
    var listClassName = "".concat(rootPrefixCls, "-item-group-list"); // menuAllProps.props.forEach(key => delete props[key])

    var listeners = MenuItemGroup_objectSpread({}, Object(props_util["getListeners"])(this));

    delete listeners.click;
    return h("li", {
      on: listeners,
      class: "".concat(rootPrefixCls, "-item-group")
    }, [h("div", {
      "class": titleClassName,
      attrs: {
        title: typeof title === 'string' ? title : undefined
      }
    }, [Object(props_util["getComponentFromProp"])(this, 'title')]), h("ul", {
      "class": listClassName
    }, [this.$slots.default && this.$slots.default.map(this.renderInnerMenuItem)])]);
  }
};
/* harmony default export */ var vc_menu_MenuItemGroup = (MenuItemGroup);
// CONCATENATED MODULE: ./src/base/vc-menu/Divider.jsx
/* harmony default export */ var Divider = ({
  name: 'MenuDivider',
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    rootPrefixCls: String
  },
  render: function render() {
    var h = arguments[0];
    var rootPrefixCls = this.$props.rootPrefixCls;
    return h("li", {
      "class": "".concat(rootPrefixCls, "-item-divider")
    });
  }
});
// CONCATENATED MODULE: ./src/base/vc-menu/index.js
// based on rc-menu 7.5.5






/* harmony default export */ var vc_menu = __webpack_exports__["e"] = (vc_menu_Menu);

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Provider; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ connect; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ create["a" /* default */]; });

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// CONCATENATED MODULE: ./src/utils/store/PropTypes.js

var storeShape = vue_types["a" /* default */].shape({
  subscribe: vue_types["a" /* default */].func.isRequired,
  setState: vue_types["a" /* default */].func.isRequired,
  getState: vue_types["a" /* default */].func.isRequired
});
// CONCATENATED MODULE: ./src/utils/store/Provider.jsx

/* harmony default export */ var Provider = ({
  name: 'StoreProvider',
  props: {
    store: storeShape.isRequired
  },
  provide: function provide() {
    return {
      storeContext: this.$props
    };
  },
  render: function render() {
    return this.$slots.default[0];
  }
});
// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(18);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);

// EXTERNAL MODULE: ./node_modules/omit.js/es/index.js
var es = __webpack_require__(13);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/proxyComponent.js
var proxyComponent = __webpack_require__(68);

// CONCATENATED MODULE: ./src/utils/store/connect.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function getDisplayName(WrappedComponent) {
  return WrappedComponent.name || 'Component';
}

var defaultMapStateToProps = function defaultMapStateToProps() {
  return {};
};

function connect(mapStateToProps) {
  var shouldSubscribe = !!mapStateToProps;
  var finalMapStateToProps = mapStateToProps || defaultMapStateToProps;
  return function wrapWithConnect(WrappedComponent) {
    var tempProps = Object(es["a" /* default */])(WrappedComponent.props || {}, ['store']);
    var props = {
      __propsSymbol__: vue_types["a" /* default */].any
    };
    Object.keys(tempProps).forEach(function (k) {
      props[k] = _objectSpread(_objectSpread({}, tempProps[k]), {}, {
        required: false
      });
    });
    var Connect = {
      name: "Connect_".concat(getDisplayName(WrappedComponent)),
      props: props,
      inject: {
        storeContext: {
          default: function _default() {
            return {};
          }
        }
      },
      data: function data() {
        this.store = this.storeContext.store;
        this.preProps = Object(es["a" /* default */])(Object(props_util["getOptionProps"])(this), ['__propsSymbol__']);
        return {
          subscribed: finalMapStateToProps(this.store.getState(), this.$props)
        };
      },
      watch: {
        __propsSymbol__: function __propsSymbol__() {
          if (mapStateToProps && mapStateToProps.length === 2) {
            this.subscribed = finalMapStateToProps(this.store.getState(), this.$props);
          }
        }
      },
      mounted: function mounted() {
        this.trySubscribe();
      },
      beforeDestroy: function beforeDestroy() {
        this.tryUnsubscribe();
      },
      methods: {
        handleChange: function handleChange() {
          if (!this.unsubscribe) {
            return;
          }

          var props = Object(es["a" /* default */])(Object(props_util["getOptionProps"])(this), ['__propsSymbol__']);
          var nextSubscribed = finalMapStateToProps(this.store.getState(), props);

          if (!shallowequal_default()(this.preProps, props) || !shallowequal_default()(this.subscribed, nextSubscribed)) {
            this.subscribed = nextSubscribed;
          }
        },
        trySubscribe: function trySubscribe() {
          if (shouldSubscribe) {
            this.unsubscribe = this.store.subscribe(this.handleChange);
            this.handleChange();
          }
        },
        tryUnsubscribe: function tryUnsubscribe() {
          if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
          }
        },
        getWrappedInstance: function getWrappedInstance() {
          return this.$refs.wrappedInstance;
        }
      },
      render: function render() {
        var h = arguments[0];
        var _this$$slots = this.$slots,
            $slots = _this$$slots === void 0 ? {} : _this$$slots,
            $scopedSlots = this.$scopedSlots,
            subscribed = this.subscribed,
            store = this.store;
        var props = Object(props_util["getOptionProps"])(this);
        this.preProps = _objectSpread({}, Object(es["a" /* default */])(props, ['__propsSymbol__']));
        var wrapProps = {
          props: _objectSpread(_objectSpread(_objectSpread({}, props), subscribed), {}, {
            store: store
          }),
          on: Object(props_util["getListeners"])(this),
          scopedSlots: $scopedSlots
        };
        return h(WrappedComponent, babel_helper_vue_jsx_merge_props_default()([wrapProps, {
          ref: "wrappedInstance"
        }]), [Object.keys($slots).map(function (name) {
          return h("template", {
            slot: name
          }, [$slots[name]]);
        })]);
      }
    };
    return Object(proxyComponent["a" /* default */])(Connect);
  };
}
// EXTERNAL MODULE: ./src/utils/store/create.js
var create = __webpack_require__(97);

// CONCATENATED MODULE: ./src/utils/store/index.js




/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return create; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function create(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = _objectSpread(_objectSpread({}, state), partial);

    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);
    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ })

}]);